import Collections from "@mui/icons-material/Collections"
import ElectricalServices from "@mui/icons-material/ElectricalServices"
import ImageIcon from "@mui/icons-material/Image"
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined"
import InsertDriveFile from "@mui/icons-material/InsertDriveFile"
import { Box, IconButton, Tooltip, Typography } from "@mui/material"
import { useTheme } from "@mui/material/styles"
import { useTranslation } from "react-i18next"
import { FaFont } from "react-icons/fa"
import { useAppSelector } from "../../hooks/useRedux"
import { AssetT } from "../../store/slices/assets.slice"

const renderTypeIcon = (type?: string) => {
    switch (type) {
        case "image":
            return <ImageIcon sx={{ fontSize: 16 }} />
        case "sequence":
            return <Collections sx={{ fontSize: 16 }} />
        case "font":
            return <FaFont size={14} />
        case "json":
        case "xml":
        case "text":
            return <ElectricalServices sx={{ fontSize: 16 }} />
        default:
            return <InsertDriveFile sx={{ fontSize: 16 }} />
    }
}

function AssetsInfoIcon() {
    const theme = useTheme()
    const { t } = useTranslation()
    const graphic = useAppSelector((state) => state.graphic.data)
    const assets = useAppSelector((state) => state.assets.data)

    const refIds = (graphic.assetsRef ?? []).map((ref) => ref.id)
    const usedAssets: AssetT[] = assets.filter((asset) => refIds.includes(asset._id))

    const isDisabled = usedAssets.length === 0

    const tooltipContent = (
        <Box sx={{ py: 0.5, maxHeight: 320, overflowY: "auto" }}>
            <Typography sx={{ fontSize: 12, fontWeight: 600, mb: 0.5 }}>
                {t("graphics:assetsUsed")}
            </Typography>
            {usedAssets.map((asset) => (
                <Box
                    key={asset._id}
                    sx={{ display: "flex", alignItems: "center", gap: 0.75, py: 0.25 }}
                >
                    {renderTypeIcon(asset.type)}
                    <Typography sx={{ fontSize: 12, wordBreak: "break-word" }}>
                        {asset.name}
                    </Typography>
                </Box>
            ))}
        </Box>
    )

    return (
        <Tooltip
            title={isDisabled ? "" : tooltipContent}
            arrow
            disableHoverListener={isDisabled}
            disableFocusListener={isDisabled}
        >
            <span style={{ display: "inline-flex" }}>
                <IconButton
                    disabled={isDisabled}
                    size="small"
                    sx={{
                        color: isDisabled
                            ? theme.palette.text.disabled
                            : theme.palette.text.primary,
                    }}
                >
                    <InfoOutlinedIcon sx={{ fontSize: 18 }} />
                </IconButton>
            </span>
        </Tooltip>
    )
}

export default AssetsInfoIcon
